import { Link } from "react-router-dom";
import { IMAGES } from "../data/site";
import { Reveal, SectionLabel } from "../components/Reveal";
import { useLang } from "../i18n";

const Tile = ({ src, alt, className = "", testId }) => (
  <Reveal className={className}>
    <div className="relative overflow-hidden group h-full border border-neon/15 rounded-sm" data-testid={testId}>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ objectPosition: "center" }}
        className="w-full h-full object-cover brightness-105 saturate-110 transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-ink/20 group-hover:bg-ink/0 transition-colors duration-700" />
      <span className="absolute bottom-4 left-4 font-head text-xs tracking-[0.25em] uppercase text-foreground/90 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
        {alt}
      </span>
    </div>
  </Reveal>
);

const TypeTile = ({ children, className = "", testId }) => (
  <Reveal className={className}>
    <div className="h-full border border-neon/15 bg-pine flex items-center justify-center p-8 group hover:bg-moss/60 transition-colors duration-500 rounded-sm" data-testid={testId}>
      {children}
    </div>
  </Reveal>
);

export default function GalleryPage() {
  const { t } = useLang();
  return (
    <main className="pt-20" data-testid="gallery-page">
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 sm:pt-24 pb-16">
        <Reveal>
          <SectionLabel number="·">{t("gal.label")}</SectionLabel>
          <h1 className="font-display uppercase leading-[0.9] tracking-tight text-6xl sm:text-8xl text-foreground">
            Gal<span className="text-neon">lery</span>
          </h1>
          <p className="text-fog text-lg mt-6 max-w-xl leading-relaxed">{t("gal.intro")}</p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 auto-rows-[240px] md:auto-rows-[260px]">
          <Tile src={IMAGES.hero} alt="Pizza con burrata appena sfornata" testId="gallery-tile-1"
            className="md:col-span-7 md:row-span-2" />
          <TypeTile className="md:col-span-5" testId="gallery-tile-2">
            <span className="font-display uppercase text-3xl sm:text-4xl text-outline-lime text-center leading-tight">
              {t("gal.fresh1")}<br />{t("gal.fresh2")}
            </span>
          </TypeTile>
          <Tile src={IMAGES.bresaola} alt="Pizza con bresaola, rucola e noci" testId="gallery-tile-3"
            className="md:col-span-5" />
          <Tile src={IMAGES.chef} alt="Il nostro pizzaiolo al lavoro" testId="gallery-tile-4"
            className="md:col-span-5 md:row-span-2" />
          <TypeTile className="md:col-span-3" testId="gallery-tile-5">
            <img src={IMAGES.logo} alt="Logo Bella" loading="lazy"
              className="w-28 h-28 rounded-full object-cover ring-2 ring-neon/40 transition-transform duration-700 group-hover:rotate-12" />
          </TypeTile>
          <Tile src={IMAGES.walnut} alt="Pizza con noci e petali di Grana" testId="gallery-tile-6"
            className="md:col-span-4" />
          <Tile src={IMAGES.pistachio} alt="Pizza al pistacchio con burrata" testId="gallery-tile-7"
            className="md:col-span-7" />
          <Tile src={IMAGES.wine} alt="I nostri vini siciliani" testId="gallery-tile-8"
            className="md:col-span-5" />
          <TypeTile className="md:col-span-3" testId="gallery-tile-9">
            <p className="font-head text-center uppercase tracking-[0.2em] text-fog text-sm leading-loose">
              {t("gal.oven1")}<br /><span className="text-neon font-display text-2xl tracking-normal">{t("gal.oven2")}</span><br />{t("gal.oven3")}
            </p>
          </TypeTile>
          <TypeTile className="md:col-span-4" testId="gallery-tile-10">
            <div className="text-center">
              <span className="font-display text-neon text-5xl">19:00</span>
              <p className="font-head uppercase tracking-[0.25em] text-fog text-xs mt-2">{t("gal.everyEvening")}</p>
              <Link to="/prenota" data-testid="gallery-cta-prenota"
                className="inline-block mt-5 border border-neon text-neon font-head font-bold text-xs tracking-[0.2em] uppercase px-6 py-3 rounded-full hover:bg-neon hover:text-ink transition-colors duration-300">
                {t("gal.book")}
              </Link>
            </div>
          </TypeTile>
          <Tile src={IMAGES.dough} alt="L'impasto lavorato a mano" testId="gallery-tile-11"
            className="md:col-span-8" />
          <Tile src={IMAGES.vintage} alt="Il pizzaiolo dei primi anni '80" testId="gallery-tile-12"
            className="md:col-span-4" />
          <Tile src={IMAGES.chefPistachio} alt="Pizze al pistacchio appena sfornate" testId="gallery-tile-13"
            className="md:col-span-4" />
          <Tile src={IMAGES.boxMan} alt="La pizza da asporto di Bella" testId="gallery-tile-14"
            className="md:col-span-4" />
          <Tile src={IMAGES.oven} alt="Il forno a legna in azione" testId="gallery-tile-15"
            className="md:col-span-4" />
        </div>
      </section>

    </main>
  );
}
